import Swiper, {Navigation, Pagination} from "swiper";

export function initFansWithDisabilitiesLanding() {
    function initFansPhotosSwiper() {
        new Swiper('#fans_photos_swiper', {
            speed: 500,
            initialSlide: 1,
            spaceBetween: 24,
            modules: [Navigation, Pagination],
            pagination: {
                el: '.fans-photo-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '.fans-photo-next',
                prevEl: '.fans-photo-prev'
            },
            breakpoints: {
                1000: {
                    spaceBetween: 0,
                },
            }
        });
    }

    if ($('#fans_photos_swiper').length) {
        initFansPhotosSwiper();
    }
}

